import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { navigate } from "gatsby";
import { Box, Button, Link, Container } from "theme-ui";
import { Pricing, Title } from "./Blocks";
import { GumroadOverlay } from "./Gumroad";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Container sx={{
      textAlign: 'center',
      width: [1, 3 / 4, 1 / 2],
      mb: [4, 4, 5]
    }} mdxType="Container">
      <h1 {...{
        "id": "hey-it-seems-that-you-dont-have-this"
      }}>{`Hey it seems that you don’t have this!`}</h1>
    </Container>
    <>
  {props.additionalCourse ? <Container sx={{
        width: [1, 3 / 4, 1 / 2],
        mb: [4, 4, 5],
        textAlign: "center"
      }} mdxType="Container">
      <p>
        Please purchase {props.title} to access this page. If you already
        purchased, check your email and login top right.
      </p>
      <GumroadOverlay variant="big" code={props.gumroadCode} text="Purchase the course" mdxType="GumroadOverlay" />
      <br />
      Cheers
      <br />
      ~Swizec
    </Container> : <>
      {props.GumroadCode ? <Container sx={{
          width: [1, 3 / 4, 1 / 2],
          mb: [4, 4, 5],
          textAlign: "center"
        }} mdxType="Container">
          <h2>Upgrade to continue!</h2>
          <GumroadOverlay variant="big" code={props.GumroadCode} price={props.Price} mdxType="GumroadOverlay" />
        </Container> : <>
          <Container sx={{
            width: [1, 3 / 4, 1 / 2],
            mb: [4, 4, 5],
            textAlign: "center"
          }} mdxType="Container">
            <h2>Buy the course to continue!</h2>
          </Container>
          <Pricing mdxType="Pricing" />
        </>}
    </>}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      